module.exports = __webpack_public_path__ + "static/media/wish-you-were-here.4a257ac0.jpg";